import { schema } from "normalizr";
import { arrayOfConversationMessages } from "./schema.conversation_messages.jsx";

const conversation = new schema.Entity(`conversations`);
const arrayOfConversations = [conversation];
const userConversation = new schema.Entity("user_conversations", {}, { idAttribute: "conversation_id" });
const arrayOfUserConversations = [userConversation];

conversation.define({
  messages: arrayOfConversationMessages,
});

export { conversation, arrayOfConversations, userConversation, arrayOfUserConversations };
